export default { sha: '88ed76478a402f21fc69f22ca969f4c692792b25', buildNumber: 'undefined' }
